module.exports = __webpack_public_path__ + "media/images/admin/icons/rss-b119639fe84ced8c1c3b9bd704bb96b1.svg";